// extracted by mini-css-extract-plugin
module.exports = {"text":"text--1KCNZ","size__small":"size__small--2910j","size__medium":"size__medium--3iuks","size__larger":"size__larger--3p5z8"};